(function ($, Cobalt, undefined) {
    var HONEYPOT_CLASSES = ["yowzer", "juju", "voodoo"];
    var choiceSelectedClass = 'choice-selected';
    var checkAvilabilityAttribute = 'data-validation-check-availability-url';
    var checkEmailAvailabilityAttribute = "data-validation-check-email-availability";


    function handleInheritedCheckbox(element, isChecked, disableChildren) {
        var $ul = element.parents("ul");
        var val = element.val();
        var $childInputs = $ul.find(".tree-parent-" + val + " input");

        if (isChecked == null) {
            isChecked = element.is(":checked");
        }
        $childInputs.attr("checked", isChecked);

        if (disableChildren) {
            if (isChecked) {
                $childInputs.attr("disabled", true);
            }
            else {
                $childInputs.removeAttr("disabled");
            }
        }

        $childInputs.each(function () { handleInheritedCheckbox($(this), isChecked, disableChildren) });

    }

    Cobalt.Forms = {
        previousActiveValues: {},
        hasUnsavedChanges: {},
        Select2Options: {},
        initialize: function () {
            var body = $('body');
            Cobalt.runOnHtmlInsert(Cobalt.FieldLists.initialize);
            Cobalt.runOnHtmlInsert(Cobalt.Forms.handleFormUnsavedWarnings);
            Cobalt.runOnHtmlInsert(Cobalt.Forms.removeHoneypots);
            Cobalt.runOnHtmlInsert(Cobalt.Forms.attachAjaxForms);
            Cobalt.runOnHtmlInsert(Cobalt.Forms.attachAjaxFileForms);
            Cobalt.runOnHtmlInsert(Cobalt.Forms.setupAvailabilityChecks);
            Cobalt.runOnHtmlInsert(Cobalt.Forms.setupEmailAvailabilityChecks);

            Cobalt.runOnHtmlInsert(Cobalt.Forms.bindDeleteLinks);
            Cobalt.runOnHtmlInsert(Cobalt.Forms.bindModalLinks);
            Cobalt.runOnHtmlInsert(Cobalt.Forms.bindFieldLocks);

            Cobalt.runOnHtmlInsert(Cobalt.Forms.handleSelectAdornment);
            Cobalt.runOnHtmlInsert(Cobalt.Forms.handlegReCaptchaRender);

            Cobalt.runOnHtmlInsert(Cobalt.Forms.setupCascadingDropdowns);

            if ($.browser.msie) {
                Cobalt.runOnHtmlInsert(Cobalt.Forms.fixIEButtons);
            }

            body.on('click', 'a[href].ajax-post, li.user-action-ajax-post > a[href]', Cobalt.Forms.bindAjaxPost);
            body.on('click', 'a[data-href].ajax-post > a[data-href]', Cobalt.Forms.bindAjaxPost);
            body.delegate('ul.user-actions > li.ajax-post > a', 'click', Cobalt.Forms.bindAjaxPost);

            jQuery.validator.addMethod('equalvalue', function (value, element) {
                return value === $(element).attr('data-validation-equal-value');
            });

            jQuery.validator.addMethod('regex', function (value, element) {
                if ($(element).attr('data-validation-optional') == 'true' && value == '') {
                    return true;
                }
                return new RegExp($(element).attr('data-validation-regex'), $(element).attr('data-validation-regex-options')).test(value);
            });


            Cobalt.runOnHtmlInsert(function ($parent) {
                Cobalt.Forms.addValidators($parent);
            });

            body.delegate('.choices .choice, .choices.choice', 'click', function () {
                var choice = $(this);
                var choices = choice.parent('.choices');
                var exclusive = choices.hasClass('choices-exclusive');
                var isMasterChoice = choice.hasClass('choices'); // if the choice is also a choice container

                choice.toggleClass(choiceSelectedClass);
                // also select all children
                if (isMasterChoice) {
                    var childChoices = choice.find('.choice');

                    if (!choice.hasClass(choiceSelectedClass)) {
                        childChoices.removeClass(choiceSelectedClass);
                    } else {
                        childChoices.addClass(choiceSelectedClass);
                    }
                }

                // unselect sibling choices
                if (exclusive) {
                    if (choice.hasClass(choiceSelectedClass)) {
                        choice.siblings('.choice').removeClass(choiceSelectedClass);
                    }
                }

                choice.trigger('choiceChanged');
            })

            body.delegate('.choices', 'reset', function () {
                var $choices = $(this);

                $choices.find('.choice.choice-selected').each(function () {
                    $(this).trigger('click');
                });
            });



            body.delegate(".inherit-parent input", "change", function () {
                var inputBox = $(this);
                handleInheritedCheckbox(inputBox, null, inputBox.attr("data-disable-children") === "true");
                var forumField = $("#field-forum");
                if (forumField.length > 0) {
                    forumField.find(".inherit-parent input").trigger('hide-hidden-inputs');
                }
            });

            Cobalt.runOnHtmlInsert(function ($parent) {
                $parent.find(".inherit-parent input:checked[data-disable-children='true']").change();
            });

            var updateButtonList = function ($buttonList) {
                $buttonList.find('label.button').each(function () {
                    var $button = $(this);
                    $button.removeClass('selected');
                    if ($(this).find('input:checked').length > 0) {
                        $button.addClass('selected');
                    }
                });
            }

            Cobalt.runOnHtmlInsert(function ($parent) {
                $parent.find('.button-list').each(function () {
                    var $buttonList = $(this);
                    updateButtonList($buttonList);
                    $(this).find("label.button").click(function () {
                        setTimeout(function () { updateButtonList($buttonList) }, 0);
                    });
                });
            });

            Cobalt.runOnHtmlInsert(function ($parent) {
                setTimeout(function () {
                    $parent.find("form.prevent-multiple-submit").each(function () {
                        var $form = $(this);
                        var form = this;

                        var submitted = false;
                        var handler = function () {
                            if (!submitted && $form.valid()) {
                                $form.find("[type=submit]").each(function () {
                                    $(this).attr("disabled", "disabled");
                                });
                                submitted = true;
                                form.submit();
                                return true;
                            } else {
                                return false;
                            }
                        };

                        $form.submit(handler);
                    });
                }, 1);

                $parent.find(".select-full-text").click(function () {
                    $(this).focus();
                    $(this).select();
                });
            });
        },
        setupCascadingDropdowns: function ($parent) {
            $parent.find('select[data-ajax-target]').each(function () {
                var $this = $(this);
                var $target = $('#' + $this.attr('data-ajax-target'));
                var url = $this.attr('data-ajax-url');
                var replacements = url.match(/{(.*?)}/gi);

                $this.attr({
                    'data-ajax-url': null,
                    'data-ajax-target': null
                });

                $this.on('change', function () {
                    var $this = $(this);
                    var _url;

                    $target.empty();
                    $target.append($('<option>').html('&mdash;').val(''));

                    if ($this.val().length) {
                        $(replacements).each(function () {
                            var replacement = this;
                            var value = replacement.substring(1, replacement.length - 1);

                            _url = url.replace(new RegExp(replacement), $this.attr(value));
                        });

                        $.get(_url, function (data) {
                            var _data = {};
                            var sortable = [];

                            $.each(data, function (k, v) {
                                $target.append($('<option>').html(v).val(k));
                            });

                            $target.attr('disabled', false);
                        });
                    } else {
                        $target.attr('disabled', true);
                    }
                });
            });
        },

        handleFormUnsavedWarnings: function ($parent) {
            var forms = $parent.find(".j-warn-unsaved-changes");
            function GetValue(element) {

                if (element.attr('type') == 'checkbox')
                    return element.attr('checked') ? true : false;

                return element.val();
            }
            var warnUser = function (e) {
                e.returnText = "The changes made to the Manual Data were not saved.";
                return e.returnText;
            }
            $.each(forms, function (i, form) {
                var id = $(form).attr("id");
                if (id == null) {
                    return;
                }
                $(form).bind("destroyed", function () {
                    Cobalt.Forms.hasUnsavedChanges[id] = false;
                    Cobalt.Forms.previousActiveValues[id] = {};
                    var otherChanges = false;
                    $.each(Cobalt.Forms.hasUnsavedChanges, function (i, val) {
                        if (Cobalt.Forms.hasUnsavedChanges[i] == true) {
                            otherChanges = true;
                        }
                    });
                    if (!otherChanges) {
                        window.onbeforeunload = null;
                    }
                });
                Cobalt.Forms.previousActiveValues[id] = {};
                Cobalt.Forms.hasUnsavedChanges[id] = false;
                $(form).find('input,select,textarea').each(function () {
                    Cobalt.Forms.previousActiveValues[id][$(this).attr('name')] = GetValue($(this));
                    $(this).change(function () {
                        var anyChanges = false;

                        $(form).find('input,select,textarea').each(function () {
                            var currentValue = GetValue($(this));

                            if (currentValue != Cobalt.Forms.previousActiveValues[$(this).attr("id")]) {
                                Cobalt.Forms.hasUnsavedChanges[id] = true;
                                anyChanges = true;
                            }
                        });

                        if (!anyChanges)
                            window.onbeforeunload = null;
                        else
                            window.onbeforeunload = warnUser;
                    });
                });
                $(form).submit(function () {

                    Cobalt.Forms.hasUnsavedChanges[id] = false;
                    var otherChanges = false;
                    $.each(Cobalt.Forms.hasUnsavedChanges, function (i, val) {
                        if (Cobalt.Forms.hasUnsavedChanges[i] == true) {
                            otherChanges = true;
                        }
                    });
                    if (!otherChanges) {
                        window.onbeforeunload = null;
                    }
                });
            });
        },
        fixIEButtons: function () {
            $(document).ready(function () {
                var buttons = document.getElementsByTagName('button');
                for (var i = 0; i < buttons.length; i++) {
                    var button = buttons[i];

                    if (button.onclick) continue;

                    button.onclick = function () {
                        for (var j = 0; j < this.form.elements.length; j++) {
                            if (this.form.elements[j].tagName == 'BUTTON') {
                                //this.form.elements[j].disabled = true;
                            }
                        }
                        this.disabled = false;
                        var valueNode = this.attributes.getNamedItem("value");
                        if (valueNode != null) {
                            this.value = valueNode.nodeValue;
                        }
                    };
                }
            });
        },

        removeErrors: function (form) {
            $(form).find("span.field-errors").remove();
        },

        attachAjaxForms: function () {
            var ajaxForms = $('form.ajax');
            $.each(ajaxForms, function (i, form) {
                var $form = $(form);

                $form.on('click', 'input[type=submit]', function () {
                    var $this = $(this);
                    Cobalt.TinyMCE.saveEditorInForm($this);
                });

                $form.ajaxForm({
                    beforeSubmit: function () {
                        $form.find(":submit").attr("disabled", "disabled");
                    },
                    success: function (result, a, b, c) {
                        if (result.Status === undefined || (result.Status !== undefined && result.Status != "invalid")) {
                            if ($form.hasClass("auto-close")) {
                                $(".ui-dialog-titlebar-close").click();
                            }
                            if ($form.hasClass("auto-reload")) {
                                document.location.reload();
                                return;
                            }
                        } else {
                            $form.find(":submit").removeAttr("disabled");
                            Cobalt.Forms.displayErrors($form, result.Errors);
                        }
                        if (result.RedirectUrl && Cobalt.Utils.isUrlCurrentSite(result.RedirectUrl)) {
                            document.location = result.RedirectUrl;
                        }
                    },
                    error: function (e) {
                        $.error(e.message, "color:red;");
                    }
                });
            });
        },

        attachAjaxFileForms: function () {
            setTimeout(function () {
                var ajaxForms = $("form").filter(function (index) {
                    return $(this).attr("ajax-form") == "true" && $(this).attr("form-type") == "file-upload";
                });
                $.each(ajaxForms, function (i, val) {
                    var $form = $(val);
                    $form.ajaxForm({
                        type: 'post',
                        beforeSubmit: function () {
                            $form.find(":submit").attr("disabled", "disabled");
                        },
                        iframe: true,
                        success: function (result, a, b, c) {
                            var jsonResult = null;
                            try {
                                jsonResult = JSON.parse(result);
                            }
                            catch (error) { }

                            if (result.indexOf("HttpRequestTooLargeException") > -1) {
                                Cobalt.Forms.displayErrors($(val), { "field-attachment": [L.Global.Files.FileTooLarge("5 MB")] });
                            }
                            else {

                                if (jsonResult != null && jsonResult.Errors != undefined) {
                                    Cobalt.Forms.displayErrors($(val), jsonResult.Errors);
                                    $(val).find(":submit").removeAttr("disabled");
                                }
                                else {
                                    $(val).find("input").val("");
                                    document.location.reload();
                                }
                            }
                        },
                        error: function () {
                            $form.find(":submit").removeAttr("disabled");
                        }
                    });
                });
            }, 1);
        },
        displayErrors: function (form, errors) {
            for (var fieldID in errors) {

                var field = $(form).find("#form-" + fieldID);
                if (!field.length) {
                    field = $(form).find("#" + fieldID);
                }

                var error = errors[fieldID];
                var errorField = $("span.field-errors[for='" + fieldID + "']");

                if (errorField.length == 0) {
                    field.after($("<span>").addClass("field-errors").attr("for", fieldID).attr("generated", "true"));
                    errorField = $("span.field-errors[for='" + fieldID + "']");
                }

                errorField.html(error.join(", "));
                errorField.show();

//                if (field.find("input").is(":text")) {
//                    field.on("keydown", function () {
//                        if ($(this).valid()) {
//                            errorField.hide();
//                        }
//                    });
//                }
            }

            Cobalt.Forms.resetReCaptchas($(form));
        },
        setupAvailabilityChecks: function ($parent) {
            var fields = $parent.find("input[" + checkAvilabilityAttribute + "]");
            fields.each(function () {
                var element = $(this);
                var parentForm = element.parents("form").first();
                element.blur(function () {
                    $.ajax({
                        url: element.attr(checkAvilabilityAttribute) + "?c=" + element.val(),
                        dataType: "json",
                        success: function (data) {
                            element.removeClass("available-yes").removeClass("available-no");
                            element.parent().find("span.username-taken").remove();
                            if (data.Available) {
                                element.addClass("available-yes");
                            }
                            else {
                                element.addClass("available-no");
                                element.after($("<span class='field-errors username-taken' htmlfor='field-username'>" + L.Global.UserRegistration.UsernameIsTaken() + "</span>"));
                            }
                            $('span#field-error-field-username').css('display', 'none');
                        }
                    });
                });
            });
        },
        setupEmailAvailabilityChecks: function ($parent) {
            var emailField = $parent.find("input#field-email");
            emailField.each(function () {
                var element = $(this);
                var url = "/user/email/available";
                element.blur(function () {
                    $.ajax({
                        url: url,
                        data: { "emailAddress": element.val() },
                        dataType: "json",
                        success: function (data) {
                            element.removeClass("available-yes").removeClass("available-no");
                            element.parent().find("span.email-taken").remove();
                            element.parent().find("span.email-not-valid").remove();
                            if (!data.Available) {
                                element.addClass("available-no");
                                element.after($("<span class='field-errors email-taken' htmlfor='field-email'>That email address is not available.</span>"));
                            }
                            if (!data.Valid) {
                                element.addClass("available-no");
                                element.after($("<span class='field-errors email-not-valid' htmlfor='field-email'>That email address is not valid.</span>"));
                            }
                            $('span#field-error-field-email').css('display', 'none');
                        }
                    });
                });
            });

        },
        removeHoneypots: function ($parent) {
            if (HONEYPOT_CLASSES.length > 0) {
                var fields = $parent.find("." + HONEYPOT_CLASSES[0]);
                for (var i = 1; i < HONEYPOT_CLASSES.length; i++) {
                    fields = fields.add($parent.find("." + HONEYPOT_CLASSES[i]));
                }
                fields.each(function () {
                    var element = $(this);
                    while (element) {
                        var parent = element.parent();
                        element.remove();
                        element = null;
                        if (parent.children().length == 0) {
                            element = parent;
                        }
                    }
                });
            }
        },
        addValidators: function ($parent) {

            var addValidation = function (elements, ruleFactory) {

                var func = function (element, realElement) {

                    var $realElement = $(realElement);
                    if ($realElement.attr("data-validation-disabled") == "true" || $(realElement.form).attr("data-validation-disabled") == "true") {
                        return;
                    }

                    var result = ruleFactory.call(element, realElement);

                    if (result) {
                        $realElement.rules('add', result);
                    }

                };


                elements.each(function () {
                    if (!this.form) {
                        var element = this;
                        $(element).find("input:not([data-validation-disabled=true])").each(function () { func(element, this); });
                    } else {
                        var that = this;
                        func(that, that);
                    }
                });
            };

            var bindValidateForm = function () {
                if ($(this).attr("data-validation-disabled") == "true")
                    return;

                $(this).validate({
                    ignore: ':hidden:not(.chosen-done)',
                    errorClass: 'field-errors',
                    errorElement: 'span',
                    errorPlacement: function (error, element) {
                        if (element.attr('type') == 'radio') {
                            $(element).parents('dd').prev('dt').append(' ').append(error);
                        } else {
                            $(element).parent().append(' ').append(error);
                        }
                    },
                    onkeyup: function (element, event) {
                        if ((event.which === 9 && this.elementValue(element) === '')) {
                            return;
                        } else if ((element.name in this.submitted || element === this.lastActive) && (element.type == "text" || element.type == "textarea")) {
                            this.element(element);
                        }
                    }
                });
            };


            if ($parent.is('form')) {
                $parent.each(bindValidateForm);
            } else {
                $parent.find('form').each(bindValidateForm);
            }


            addValidation($parent.find('[data-validation-required]').not('.text-editor'), function () {
                var validationMessage = $(this).attr("data-validation-required-message");
                return {
                    required: true,
                    messages: {
                        required: (validationMessage != undefined ? validationMessage : L.Global.Common.RequiredErrorMessage())
                    }
                };
            });

            addValidation($parent.find('[data-validation-length]'), function () {
                var attr = $(this).attr('data-validation-length');
                var validationMessage = $(this).attr("data-validation-length-message");
                var range = attr.split('..');
                if (range[1] == "" || range[1] == undefined) {
                    range[1] = Infinity;
                }
                return {
                    minlength: range[0],
                    maxlength: range[1],
                    messages: {
                        minlength: (validationMessage != undefined ? validationMessage : L.Global.Common.LengthErrorMessageMinimum(range[0])),
                        maxlength: (validationMessage != undefined ? validationMessage : L.Global.Common.LengthErrorMessageMaximum(range[1]))
                    }
                };
            });

            addValidation($parent.find('[data-validation-range]'), function () {
                if ($(this).hasClass("date-time") || $(this).hasClass("date") || $(this).hasClass("timespan")) {
                    return;
                }
                var attr = $(this).attr('data-validation-range');
                var validationMessage = $(this).attr("data-validation-range-message");
                var range = attr.split('..');
                if (range[1] != "") {
                    return {
                        min: range[0],
                        max: range[1],
                        messages: {
                            min: (validationMessage != undefined ? validationMessage : L.Global.Common.IntegerValueErrorMessageMinimum(range[0])),
                            max: (validationMessage != undefined ? validationMessage : L.Global.Common.IntegerValueErrorMessageMaximum(range[1]))
                        }
                    };
                } else {
                    return {
                        min: range[0],
                        messages: {
                            min: (validationMessage != undefined ? validationMessage : L.Global.Common.IntegerValueErrorMessageMinimum(range[0]))
                        }
                    };
                }
            });

            addValidation($parent.find('[data-validation-equal-value]'), function () {
                var attr = $(this).attr('data-validation-equal-value');
                var validationMessage = $(this).attr("data-validation-equal-value-message");
                return {
                    equalvalue: attr,
                    messages: {
                        equalvalue: function (value, element) {
                            return (validationMessage != undefined ? validationMessage : L.Global.Common.EqualErrorMessage($(element).val(), value));
                        }
                    }
                };
            });

            addValidation($parent.find('[data-validation-equal-field]'), function () {
                var field = $(this).attr('data-validation-equal-field');
                var validationMessage = $(this).attr("data-validation-equal-field-message");
                return {
                    equalTo: '#{0}'.format(field),
                    messages: {
                        equalTo: function (value, element) {
                            if (validationMessage != undefined) {
                                return validationMessage;
                            }
                            else {
                                return L.Global.Common.EqualErrorMessage($(element).val(), $(value).val());
                            }

                        }
                    }
                };
            });

            addValidation($parent.find('[data-validation-regex]'), function () {
                var pattern = $(this).attr('data-validation-regex');
                var validationMessage = $(this).attr("data-validation-regex-message");
                return {
                    regex: pattern,
                    messages: {
                        regex: (validationMessage != undefined ? validationMessage : 'Text does not match required pattern')
                    }
                };
            });

            addValidation($parent.find('[data-validation-file-extension]'), function () {
                var ext = $(this).attr('data-validation-file-extension');
                return {
                    accept: ext,
                    messages: {
                        accept: ext.split('|').join(', ')
                    }
                };
            });

            $parent.find('[data-autocomplete-url]').each(function () {
                var $field = $(this);
                var url = $field.attr('data-autocomplete-url');
                var autoCompleteWidth = $field.attr('data-autocomplete-width');
                var autoCompleteMinChars = $field.attr('data-min-chars');
                var autoCompleteMaxResults = $field.attr('data-max-results');
                var autocomplete = $field.autocomplete(url, {
                    dataType: 'json',
                    max: (autoCompleteMaxResults ? parseInt(autoCompleteMaxResults) : 25),
                    cache: 500,
                    minChars: (autoCompleteMinChars ? parseInt(autoCompleteMinChars) : 1),
                    scroll: false,
                    selectFirst: false,
                    width: autoCompleteWidth,
                    parse: function (data) {
                        var rows = new Array();
                        if (data == null) {
                            return rows;
                        }
                        for (var i = 0; i < data.length; i++) {
                            rows[i] = { data: data[i], value: data[i].Value, result: data[i].Key };
                        }
                        return rows;
                    },
                    formatItem: function (row, i, n) {
                        return row.Display || row.Key;
                    }
                }).result(function (event, data, formatted) {
                    var id = this.id;
                    $('#' + id + '-previous').val(data.Key);
                    $('#' + id + '-symbol').val(data.Value);
                });
            });


            $parent.find('[data-autocomplete-search-url]').each(function () {
                var $field = $(this);
                var url = $field.attr('data-autocomplete-search-url');
                var autoCompleteWidth = $field.attr('data-autocomplete-width');
                var autoCompleteMinChars = $field.attr('data-min-chars');
                var autoCompleteMaxResults = $field.attr('data-max-results');
                var autoCompleteClass = $field.attr('data-class');
                var autocomplete = $field.autocomplete_search(url, {
                    resultsClass: 'ac_results' + (autoCompleteClass ? ' ' + autoCompleteClass : ''),
                    loadingClass: 'ac_loading' + (autoCompleteClass ? ' ' + autoCompleteClass : ''),
                    dataType: 'json',
                    max: (autoCompleteMaxResults ? parseInt(autoCompleteMaxResults) : 25),
                    cache: 500,
                    minChars: (autoCompleteMinChars ? parseInt(autoCompleteMinChars) : 1),
                    scroll: false,
                    selectFirst: false,
                    width: autoCompleteWidth,
                    parse: function (data) {
                        var rows = new Array();
                        if (data == null) {
                            return rows;
                        }
                        for (var i = 0; i < data.length; i++) {
                            rows[i] = { data: data[i], value: data[i].Value, result: data[i].Key };
                        }
                        return rows;
                    },
                    formatItem: function (row, i, n) {
                        return row.Display || row.Key;
                    }
                }).result(function (event, data, formatted) {
                    var id = this.id;
                    $('#' + id + '-previous').val(data.Key);
                    $('#' + id + '-symbol').val(data.Value);
                });
            });

            $parent.find('form.listing-filters').submit(function () {

                var form = $(this);
                if (form.hasClass("ajax-listing")) {
                    return true;
                }
                var action = this.action;

                var arr = $(this).formToArray();
                for (var i = arr.length - 1; i >= 0; i--) {
                    if (arr[i].value == "") {
                        arr.splice(i, 1);
                    }
                }
                var qs = $.param(arr);
                var viewState = "";

                if (action.indexOf("#") != -1) {
                    viewState = action.substring(action.indexOf("#"));
                    action = action.substring(0, action.indexOf("#"));
                }
                if (!viewState) {
                    viewState = window.location.hash;
                }

                var newLocation = "";

                if (qs == "") {
                    newLocation = action + viewState;
                }

                newLocation = action + "?" + $.param(arr) + viewState;

                form.attr("action", newLocation);

                return true;
            });

            $parent.find('.listing .col-delete a').click(function (e) {
                e.preventDefault();

                if (!confirm('Delete?')) return;

                var $link = $(this);
                var href = $link.attr('href');

                $.post(href, function () {
                    window.location.reload();
                });
            });
        },

        bindDeleteLinks: function ($parent) {
            $parent.find('.user-actions .user-action-delete[data-delete-url][data-redirect-url]').click(function (e) {
                if (!confirm('Delete?')) {
                    return;
                }

                var $action = $(this);
                var postUrl = $action.attr('data-delete-url');

                $.post(postUrl, function (data) {
                    var redirectUrl = $action.attr('data-redirect-url');
                    window.location = redirectUrl;
                });

                e.preventDefault();
            });
        },

        bindFieldLocks: function ($parent) {
            $parent.find("[data-lock-for]").click(Cobalt.Forms.handleFieldLockClick);
        },

        handleFieldLockClick: function (e) {
            e.preventDefault();
            var lockForID = $(this).attr("data-lock-for");
            if (lockForID) {
                var isLocked = $(this).hasClass("unlock") ? true : false;
                var lockForField = $("#" + lockForID);
                if (lockForField.length > 0) {
                    if (isLocked) {
                        $(this).removeClass("unlock").addClass("lock");
                        lockForField.removeAttr("readonly");
                    }
                    else {
                        $(this).removeClass("lock").addClass("unlock");
                        lockForField.attr("readonly", "readonly");
                    }
                }
            }
        },

        bindModalLinks: function ($parent) {
            // this function can get called multiple times. until this can be changed
            // we need to make sure that we don't hook into the click event for modal
            // links multiple times.
            $parent.find('.modal-link').off('click', Cobalt.Forms.handleModalLinks);
            $parent.find('.modal-link').on('click', Cobalt.Forms.handleModalLinks);
        },

        handleModalLinks: function (e) {
            e.preventDefault();

            var $link = $(this);
            Cobalt.Forms.loadModalFromLink($link);
        },
        loadModalFromLink: function($link) {
            if ($link.hasClass('modal-loading')) {
                return;
            }

            if ($link.hasClass("modal-disabled")) {
                return;
            }

            var href = $link.attr('data-modal-href') || $link.attr('href');
            var title = $link.attr('data-title');

            if (!href) {
                throw "No href in model-link";
            }

            var maxWidth = parseInt($link.attr('data-max-width'));
            var minWidth = parseInt($link.attr('data-min-width'));
            var maxHeight = parseInt($link.attr('data-max-height'));
            var modalWidth = parseInt($link.attr("data-modal-width"));
            var modalHeight = parseInt($link.attr("data-modal-height"));
            var disableScrolling = $link.attr('data-modal-allowpagescrolling') == 'true' ? false : true;

            var modalClass = $link.attr("data-modal-class") || "modal";
            var autoHeight = $link.attr('data-auto-height') == "true";

            var sizeToWindow = $link.attr("data-modal-size-to-window") != null || maxWidth > 0 || minWidth > 0 || maxHeight > 0;

            Cobalt.Modal.openModal(href, title, modalWidth, modalHeight, modalClass, disableScrolling, sizeToWindow, minWidth, maxWidth, maxHeight, autoHeight);
        },

        loadModal: function (href, title, maxWidth, minWidth, maxHeight, autoHeight) {


            $.get(href, function (data) {
                var $html = $(data);
                $html.dialog(
                {
                    draggable: false,
                    title: title,
                    modal: true,
                    resizable: false,
                    dialogClass: 'modal',
                    close: function (event, ui) {
                        $html.dialog("destroy");
                        $html.remove();
                    }
                }
                );
                var container = $html.dialog("widget");
                Cobalt.triggerHtmlInsert($html.parent());
                container.center({ sizeToWindow: true, minWidth: minWidth, maxWidth: maxWidth, maxHeight: maxHeight, autoHeight: autoHeight });
            });
        },

        bindAjaxPost: function (e) {
            e.preventDefault();
            var $this = $(this);

            if ($this.hasClass('disabled') || $this.hasClass('loading')) {
                return;
            }

            var confirmMessage = $this.attr('data-confirm-message');

            if (!confirmMessage && $this.hasClass('confirm'))
                confirmMessage = 'Are you sure?';

            if (confirmMessage !== undefined && !confirm(confirmMessage))
                return;

            if (!$this.hasClass('silent')) {
                $this.addClass('loading');
            }

            Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                Cobalt.Forms.AjaxPostSubmit($this, token);
            });
        },
        AjaxPostSubmit: function ($control, token) {

            var parentNodeSelector = $control.attr("data-parent-selector");
            var href = $control.attr('href');
            var $form = $('<form>').attr('method', 'post').attr('action', href).hide();
            var $tokenInput = $('<input>').attr('name', 'request-verification-token').attr('type', 'hidden').val(token);
            $form.append($tokenInput);
            $control.parent().append($form);

            var deferred = $.Deferred();

            $form.ajaxSubmit(function () {
                deferred.resolve();

                $control.removeClass('loading');

                if (parentNodeSelector !== undefined && parentNodeSelector !== "") {
                    var $parentNode = $control.parents(parentNodeSelector);
                    $parentNode.fadeOut(function () {
                        $parentNode.remove();
                    });
                }

                if ($control.data('redirect-url')) {
                    self.location.replace($control.data('redirect-url'));
                }
                else if (!$control.hasClass('no-refresh')) {
                    self.location.reload();
                }
            });

            return deferred.promise();
        },
        initializeSelect2: function ($el) {
            var id = $el.attr('id');
            var options = {};

            if (this.Select2Options[id]) {
                options = this.Select2Options[id];
            }
            var colbaltDefaults = {
                width: 'resolve',
                dropdownAutoWidth: true,
                dropdownCss: {
                    "min-width": "180px"
                }
            };

            var colbaltDefaults = {
                width: 'resolve',
                dropdownAutoWidth: true,
                dropdownCss: {
                    "min-width": "180px"
                }
            };

            $el.select2($.extend(true, {}, colbaltDefaults, options));
        },
        handleSelectAdornment: function ($parent) {
            // Handle Chosen
            $parent.find("select.is-chosen-select").each(function () {
                var $sel = $(this);
                var chosenConfig = $sel.data('chosen-config');
                try {
                    if (chosenConfig) {
                        $sel.chosen(chosenConfig);
                    } else {
                        $sel.chosen();
                    }
                }
                catch (error) {

                }
            });

            var Select2Options = {};

            // Handle Select2
            $parent.find("select.is-select2-select").each(function () {
                try {
                    Cobalt.Forms.initializeSelect2($(this));
                }
                catch (error) {
                    $.log(error);
                }
            });
        },
        handlegReCaptchaRender: function ($parent) {
            if ($(".g-recaptcha").length > 0 && typeof grecaptcha !== 'undefined') {
                $parent.find("div.g-recaptcha").each(function() {
                    try {
                        var siteKey = $(this).attr("data-sitekey");
                        var theme = $(this).attr("data-theme");

                        var widgetID =  grecaptcha.render(this, { 'sitekey': siteKey, 'theme': theme});
                         $(this).attr("widgetID",widgetID);

                    } catch (error) {
                        $.log(error);
                    }
                });
            }
        },
        resetReCaptchas: function ($parent) {
            $("div.g-recaptcha").each(function() {
                grecaptcha.reset($(this).attr('widgetID'));
            });
        }
    };
})(jQuery, Cobalt);



// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Forms.js